import {SequenceDuplicateVettingResponse} from "../../types/DuplicateOrdersVettingResponse";
import {AccountStore} from "../../../../../account/store/AccountStore";

export class MultiDuplicateOrdersNotificationDialogController {

    /** @ngInject */
    public constructor(
        private readonly duplicates: SequenceDuplicateVettingResponse[],
        private readonly accountStore: AccountStore) {
    }

    public getAccount(portfolioId: number) {
        let accountNumber;
        this.accountStore
            .accounts
            .take(1)
            .subscribe((accounts) => {
                const v = accounts.find((a) => a.id === portfolioId);
                accountNumber = v;
            });
        return accountNumber;
    }
}
